// initial state
const state = {
    layout: 'app-layout',
}

const getters = {
    layout: state => state.layout,
}

const actions = {
    setLayout({ commit }, layout) {
        commit('SET_LAYOUT', layout)
    },
}

const mutations = {
    SET_LAYOUT(state, layout) {
        state.layout = layout
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
